import $ from 'jquery';
import * as bootstrap from 'bootstrap';
/*order*/
/*$( "body" ).on( "click", "#choosebtn", function() {
    chooseAdddress($(this).attr("data-id"));
});
function WriteAddress(i){
        $html="<b>"+addressArr[i].name+"</b>";
        $html+=("<br/>"+addressArr[i].address+", "+addressArr[i].zip+", "+addressArr[i].city+" "+addressArr[i].province);
        $html+=("<br/>"+addressArr[i].phone);
        $html+=("<br/><b>"+addressArr[i].company+"</b>,  "+addressArr[i].cfpiva+" <b>Codice Destinatario</b>: "+addressArr[i].codicedestinatario);
        $('#modal-address .modal-body .address').html($html);
        $('#modal-address .modal-body #choosebtn').attr("data-id",i);
}

$( "body" ).on( "click", "#leftbtn", function() {
    var i=parseInt($('#modal-address .modal-body #choosebtn').attr("data-id"))-1;
    if(i>=0){
         WriteAddress(i)
        if(i==0){
          $(this).hide();
        }
        if(addressArr.length>1){
            $('#modal-address .modal-body #rightbtn').show();
        }
    }
});
$( "body" ).on( "click", "#rightbtn", function() {
    var i=parseInt($('#modal-address .modal-body #choosebtn').attr("data-id"))+1;
    if(i<addressArr.length){
         WriteAddress(i)
        if(i==addressArr.length-1){
          $(this).hide();
        }
        if(addressArr.length>1){
            $('#modal-address .modal-body #leftbtn').show();
        }
    }
});*/
$( "body" ).on( "click", "#cleanaddressbook", function() {
    $("#checkoutform #address").val("");
    $("#checkoutform #city").val("");
    $("#checkoutform #name").val("");
    $("#checkoutform #firstname").val("");
    $("#checkoutform #lastname").val("");
    $("#checkoutform #province").val("");
    $("#checkoutform #zip").val("");
    $("#checkoutform #phone").val("");
    $("#checkoutform #company").val("");
    $("#checkoutform #piva").val("");
    $("#checkoutform #cf").val("");
    $("#checkoutform #codice_destinatario").val("");
});
function chooseAdddress(i){
    var $address=addressArr[i];
    $('#checkoutform #address').val($address.address);
    $('#checkoutform #city').val($address.city);
    $('#checkoutform #name').val($address.name);
    $('#checkoutform #province').val($address.province);
    $('#checkoutform #zip').val($address.zip);
    $('#checkoutform #phone').val($address.phone);
    $('#checkoutform #company').val($address.company);
    $('#checkoutform #piva').val($address.piva);
    $('#checkoutform #cf').val($address.cf);
    $('#checkoutform #codice_destinatario').val($address.codicedestinatario);
    $('#checkoutform #pec').val($address.pec);
    //$('#modal-address').modal('hide') ;
}
window.chooseAdddress=chooseAdddress;
function openModal (){
    $('#modal-dati-confirm').modal('show');
}
window.openModal=openModal;
var dataother;
$( document ).ready(function() {
$('#modal-codice').on( "click", "#azienda ", function() {
    $('#modal-codice').modal('hide');
});
$('#modal-codice').on( "click", "#privato ", function() {
    if($("#codice_destinatario").val()==""){
        $("#codice_destinatario").val("0000000");
    }
    $("#priv").val("1");
    $('#modal-codice').modal('hide');
    $('#checkoutform').submit();
});
$('#modal-cfpiva ').on( "click", "#azienda ", function() {
    $('#modal-cfpiva').modal('hide');
});
$('#modal-piva ').on( "click", "#azienda ", function() {
    $('#modal-piva').modal('hide');
});
$('#modal-piva').on( "click", "#privato ", function() {
    if($("#codice_destinatario").val()==""){
        $("#codice_destinatario").val("0000000");
    }
    $("#priv").val("1");
    $('#modal-piva').modal('hide');
    $('#checkoutform').submit();
});
$('#checkoutform').on( "submit", function(e) {
    /*alert(IsEmail($("#pec").val()));
    alert($("#codice_destinatario").val().length);
    alert($("#checkoutform #priv").val());
    return false;*/
    //e.preventDefault();
    console.log($("#checkoutform #piva").val()=="");

    console.log($("#checkoutform #priv").val()=="0");

    if(!IsEmail($("#pec").val()) && $("#codice_destinatario").val().length!==7 && $("#checkoutform #priv").val()=="0"){
        $('#modal-codice').modal();
        $('#modal-codice').modal('show');
        return false;
    }
    //#INSERISCO qui il controllo su cidice fiscale o partita iva
    //#primo controllo entrambi errati
    //
    if(($("#checkoutform #piva").val().length<11) && $("#checkoutform #cf").val().length<16){
        $('#modal-cfpiva').modal();
        $('#modal-cfpiva').modal('show');
        return false;
    }
    //#CONTROLLO se la partita iva è vuota

    if($("#checkoutform #piva").val()==""   && $("#checkoutform #priv").val()=="0") {
        $('#modal-piva').modal();
        $('#modal-piva').modal('show');
        return false;
    }
    return true;
    // Get the Login Name value and trim it
    //var name = $.trim($('#log').val());
    // Check if empty of not
    //if (name  === '') {
    //}
});
$( "body" ).on( "click", "#bonifico", function() {
    //alert("bonifico");
    if(!$(this).hasClass("selected")){
        $("#metodo").html("Bonifico Bancario");
    }else{
        $.ajax({
            method: "POST",
            url: "/site/finishcheckout",
            data: {payment_type:"Bonifico Bancario"}
        })
            .done(function( msg ) {
                window.location.href="/site/thankyou/"+ $("#order_id").val()+"";
            })
    }
    $(this).addClass("selected");
    $(this).html($(this).attr("data-selected"));
})
$( "body" ).on( "click", "#acquistogratis", function() {
    if(!$(this).hasClass("selected")){
        $("#metodo").html("Nessun Pagamento");
    }else{
        $.ajax({
            method: "POST",
            url: "/site/finishcheckout",
            data: {payment_type:"Nessun Pagamento"}
        })
            .done(function( msg ) {
                window.location.href="/site/thankyou/"+ $("#order_id").val()+"";
            })
    }
    $(this).addClass("selected");
    $(this).html($(this).attr("data-selected"));
})


    $("#"+window.actionid).addClass('selected');
    $(".card-holder").click(function() {
    window.location = $(this).parent().find('a').attr('href');
  return false;
});
/*item*/

$( 'body').on( 'click', '.otheritem', function() {
$('#modal-others').modal('hide');
  $.ajax({
			method: 'POST',
			url: '/site/checkotheritem',
			data: {'id':$(this).attr('data-id')}
		})
		.done(function( data ) {
                    if(data!=='KO'){
                    dataother=data;
                    $('#modal-other').modal();                      // initialized with defaults
                    $('#modal-other').modal({ keyboard: false });  // initialized with no keyboard
                    $('#modal-other').modal('show');   
                    var people="<b>Credits</b><br/>";
                    if(data.team_campaign){
                    var $peoples=(JSON.parse(data.team_campaign));
                            for(var $people in $peoples){
                                people+=$peoples[$people]["firstname"]+" "+$peoples[$people]["lastname"]+" "+$peoples[$people]["role"]+"<br/>";
                            }
                    }
                     $('#modal-other .modal-body #content').html("Vuoi revuperare i dati da questa campagna<br/><b>"+data.campaign+"</b><br/>"+data.client_campaign+" "+data.subject_campaign+" "+data.product_campaign+"<br/>"+people)
                 }

        });
});
$( '#othersbtn').click(function() {
  $.ajax({
			method: "POST",
			url: "/site/loadotheritems",
			data: {}
		})
		.done(function( data ) {
                    if(data!=="KO"){
                    dataother=data;
                    var $text="<ul>";
                    for(var $campaign in dataother){
                            if(dataother[$campaign].campaign!=null){
                                  $text+="<li class='otheritem' data-id='"+dataother[$campaign].id+"'>"+(dataother[$campaign].item_name+" "+dataother[$campaign].campaign)+"</li>";
                            }
                     }
                      $text+="</ul>";
                      $('#modal-others .modal-body #content').html($text);
                      $('#modal-others').modal();                      // initialized with defaults
                      $('#modal-others').modal({ keyboard: false });  // initialized with no keyboard
                      $('#modal-others').modal('show');

                   /* $('#modal-other').modal();                      // initialized with defaults
                    $('#modal-other').modal({ keyboard: false });  // initialized with no keyboard
                    $('#modal-other').modal('hide');*/
                     if(data.team_campaign){
                     var $peoples=(JSON.parse(data.team_campaign));
                    var people="<b>Credits</b><br/>";
                    for(var $people in $peoples){
                        people+=$peoples[$people]["firstname"]+" "+$peoples[$people]["lastname"]+" "+$peoples[$people]["role"]+"<br/>";
                    }
                     $('#modal-other .modal-body #content').html("Vuoi revuperare i dati da questa campagna<br/><b>"+data.campaign+"</b><br/>"+data.client_campaign+" "+data.subject_campaign+" "+data.product_campaign+"<br/>"+people)
                    /**/
                 }}
        });
});
$( "body").on( "click", "#otherbtn ", function() {
    $("#client_campaign").val(dataother.client_campaign);
    $("#subject_campaign").val(dataother.subject_campaign);
    $("#product_campaign").val(dataother.product_campaign);
    $("#campaign").val(dataother.campaign);
    $("#agenzia").val(dataother.agenzia);
    $("#produzione").val(dataother.produzione);
    $("#mention").val(dataother.mention);
    $("#aidescription").val(dataother.aidescription);
    $("#ai").val(dataother.ai);
    $("#client_campaign").trigger("change");
    $("#subject_campaign").trigger("change");
    $("#product_campaign").trigger("change");
    $("#campaign").trigger("change");
    $("#agenzia").trigger("change");
    $("#produzione").trigger("change");
    if(dataother.mention=="|bestuseofyoutube"){
        $("#checkbest").addClass("active");
    }
    if(dataother.ai=="1"){

        $("body .checkai[data-value='1']").trigger("click")
    }
    if(dataother.team_campaign){
    $( "#peoplecampaign .personcampaign" ).remove();
    var $peoples=(JSON.parse(dataother.team_campaign));
        if($peoples.length>0){
           var  $countpeople=0;
            for(var $people in $peoples){
                var $html='<div class="row personcampaign"><div class="col-md-3"><label><span class="label">firstname</span></label><input class="black" type="text" name="firstname" id="firstname'+$countpeople+'" required="" placeholder="Nome" value="'+$peoples[$people]["firstname"]+'"></div><div class="col-md-3"><label><span class="label">lastname</span></label><input class="black" type="text" name="lastname" id="lastname'+$countpeople+'" required="" placeholder="Cognome" value="'+$peoples[$people]["lastname"]+'"></div><div class="col-md-4"><label><span class="label">role</span></label><input class="black" type="text" name="role" id="role'+$countpeople+'" required="" placeholder="Ruolo" value="'+$peoples[$people]["role"]+'"></div><div class="col-md-1 icons"><label><span class="label">&nbsp;</span></label><span class="glyphicon glyphicon glyphicon-arrow-up"></span><br/><span class="glyphicon glyphicon glyphicon-arrow-down"></span><span class="glyphicon glyphicon glyphicon-remove"></span></div></div>'
                $("#peoplecampaign").append($html); 
                 $countpeople++;
                }

    }   }$('#modal-other').modal('hide');$('#modal-others').modal('hide');
    
});
/*chart*/
$( "body" ).on( "click", ".addtochart", function() {
    var product_id=($(this).attr("data-pid"));
    var product_quantity=($(this).prev('input').val()!==undefined)?($(this).prev('input').val()):(1);
    if(isGuest){
     //   $('#modal-login').modal()                      // initialized with defaults
	//$('#modal-login').modal({ keyboard: false })   // initialized with no keyboard
	//$('#modal-login').modal('show');
        console.log("chartlogin");
        $('#login').trigger('click');
        setCookie("PID",product_id,60*1000);
        setCookie("PQ",product_quantity,60*1000);
    }else{
    $.ajax({
			method: "POST",
			url: "/site/additemtochart",
			data: {product_id:product_id,product_quantity:product_quantity}
		})
		.done(function( msg ) {
                         $.ajax({
			method: "POST",
			url: "/site/quickchart",
			data: {}
                        })
                        .done(function( msg ) {
                                $("#contentchart ").html(msg);
                                $("#contentchart").addClass('hover');
                                setTimeout(function(){  $("#contentchart").removeClass('hover') }, 3000);
                        });    

		});}
});
$( "body" ).on( "click", ".add", function() {
    var product_id=($(this).attr("data-pid"));
                $.ajax({
			method: "POST",
			url: "/site/additemtochart",
			data: {product_id:product_id,product_quantity:1}
		})
		.done(function( msg ) {
                         $.ajax({
			method: "POST",

			url: "/site/quickchart",
			data: {}})
                        .done(function( msg ) {
                         $.ajax({
			method: "POST",
			url: "/site/viewchart",
			data: {}
                        })
                        .done(function( msg ) {
                                $("#viewchart").html(msg);
                        $.ajax({
			method: "POST",
			url: "/site/quickorder",
			data: {}
                        })
                        .done(function( msg ) {
                                $("#contentorder").html(msg);
                        })
                        
		});
        });
			
		});
});
$( "body" ).on( "click", ".open-bonifico", function() {
        console.log($(this).attr("data-id"));
        var order_id=($(this).attr("data-id"));
        $.ajax({
            method: "POST",
            url: "/site/orderbonifico",
            data: {order_id:order_id}
        }).done(function( msg ) {
            $("#modal-bonifico #dynamicContent").html(msg);
            /*var myModal = new bootstrap.Modal(document.getElementById('modal-bonifico'), {
               keyboard: false
           })
           /* myModalEl = document.getElementById('modal-bonifico');
           myModal.show(myModalEl );*/
            $("#modal-bonifico")
                .modal({keyboard: false})
                .modal('show');
        })
    })
$( "body" ).on( "click", ".open-ricevuta", function() {
        $("#fileuploader_receipt").attr("data-id",$(this).attr("data-id"));
        $("#modal-ricevuta-bonifico #result").hide();
        $("#fileuploader_receipt").show();
        var msg="<h2>Inviaci la ricevuta di avvenuto bonifico per l'ordine "+$(this).attr("data-id")+"</h2>";
        msg+="<p>Per velocizzare le procedure di verifica di pagamento di questo ordine e poter confermare le tue entries, segnalaci l'avvenuto pagamento caricando la ricevuta in formato .JPG, .PDF ";
        $("#modal-ricevuta-bonifico #dynamicContent").html(msg);
        $("#modal-ricevuta-bonifico")
            .modal({keyboard: false})
            .modal('show');
        $("#fileuploader_receipt").uploadFile({
            url:"/"+window.controllerid+"/sendreceiptbonifico",
            fileName:"file",
            allowedTypes:$(this).attr("data-types"),
            maxFileSize:$(this).attr("data-size"),
            showStatusAfterSuccess:false,
            formData: { order_id: $(this).attr("data-id")},
            onSuccess:function(files,data,xhr,pd)
            {
                $("#modal-ricevuta-bonifico #result").show();
                $("#fileuploader_receipt").hide();
            },
            onError: function(files,status,errMsg,pd)
            {
                console.log(errMsg);
            }
        });

        /*order_id=($(this).attr("data-id"));
        $.ajax({
            method: "POST",
            url: "/site/orderbonifico",
            data: {order_id:order_id}
        }).done(function( msg ) {
        })*/
    })
$( "body" ).on( "click", ".less,.remove", function() {
               var  product_id=($(this).attr("data-pid"));
                $.ajax({
			method: "POST",
			url: "/site/removeitemtochart",
			data: {product_id:product_id,number:$(this).attr("data-number")}
		})
		.done(function( msg ) {
                         $.ajax({
			method: "POST",
			url: "/site/quickchart",
			data: {}
                        })
                        .done(function( msg ) {
                                 $("#contentchart").html(msg);
                        $.ajax({
			method: "POST",
			url: "/site/viewchart",
			data: {}
                        })
                        .done(function( msg ) {
                               $("#viewchart").html(msg);
                        })
                        
		});
        });
});
$( "body" ).on( "mouseenter",'#contentchart',function(){
   //$("#quickchart").show();
});
$(document).on('click', '.js-trigger-modal', function(ev) {
		ev.preventDefault();

		var modal = $(this).attr('data-modal');

		$('.modal').modal('hide');

		$(modal)
			.modal({keyboard: false})
			.modal('show');
});
});